// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1278":"882673c9","4227":"aa278c09"}[chunkId] + ".chunk.css";
};